const consignmentImageFormSchema = {
  type: 'object',
  // required: ['consignmentId', 'file'],
  required: ['file'],
};

export { consignmentImageFormSchema };
